import type { SocketEnv, SocketRequestProps } from '../../types/socket';

export type EnrichContext = {
  apiVersion: string | null;
  apiCode: string | null;
  accessToken: string | null;
  env: SocketEnv;
  isClockingApp: boolean;
  uuid: string;
};

/**
 * Enrichit les props de requête avec le contexte auth/tenant avant émission socket.
 * Mutation intentionnelle du paramètre props (comportement original Api.js).
 */
export function enrichRequestProps(props: SocketRequestProps, context: EnrichContext): SocketRequestProps {
  props.apiVersion = context.apiVersion ?? undefined;

  if (context.env.parameters) {
    props.clientCode = context.env.parameters.client_code;
  }

  if (!props.apiCode && context.apiCode) {
    props.apiCode = context.apiCode;
  }

  if (context.accessToken) {
    props.accessToken = context.accessToken;
  }

  props.isClockingApp = context.isClockingApp;

  if (context.isClockingApp) {
    props.uuid = context.uuid;
  }

  return props;
}
